// src/features/calendar/constants.ts
// PlannedLayer Sidebar 寬度常數

export const SIDEBAR_WIDTH_EXPANDED = 280;    // 大螢幕桌面版展開寬度（> 1280px）
export const SIDEBAR_WIDTH_TABLET = 240;      // 平板/小筆電展開寬度（641-1280px）
export const SIDEBAR_WIDTH_COMPACT = 200;     // 小平板展開寬度（<=1024px）
export const SIDEBAR_WIDTH_COLLAPSED = 48;    // 收合寬度（圖示條）
export const SIDEBAR_PADDING = 16;            // pl-2 (8px) + pr-2 (8px)
